import React from "react";
import { Grid, Backdrop, CircularProgress, Snackbar } from "@material-ui/core";
import { properties as AppData } from "AppData";
import { Alert } from "@material-ui/lab";
import ComponenteGenericoFormio from "components/commons/componenteGenericoFormio/componenteGenericoFormio";
import { texts, objComponentFormio } from "./PageAccesoConContrasenaData";
import useFunctions from "./PageAccesoConContrasenaFunctions";
import useStyles from "./PageAccesoConContrasenaStyle";
import 'BootstrapWrapper.scss';

export default function PageAccesoConContrasena() {
  const { style } = useStyles();
  const customStyle = style();

  const {
    handleOnSubmit,
    handleCustomEvents,
    isLoading,
    alerts,
    message,
    setMessage
  } = useFunctions();

  // Se inserta el nombre del título de la página
  document.title = AppData.TITULO_PAGINA + texts.PAGE_TITLE;

  return (
    <main>
      {/** El nombre de esta clase, tiene que coincidir con el nombre de la clase que se encuentra en el fichero BootstrapWrapper.scss */}
      <Grid className="componenteGenericoFormio">
        <Grid className={customStyle.gridTitulo}>
          <h2 className={customStyle.tituloPagina}>{texts.PAGE_TITLE}</h2>
        </Grid>
        <Grid className={customStyle.backgroundRectangle}>
          <ComponenteGenericoFormio
            {...objComponentFormio}
            onSubmit={handleOnSubmit}
            onCustomEvent={handleCustomEvents}
          />
        </Grid>
      </Grid>
      <Backdrop className={customStyle.classBackdrop} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {alerts.map((m) => (
        <Snackbar
          key = "snackbar"
          open={message.msg}
          autoHideDuration={5000}
          onClose={() => setMessage({ severity: "", msg: "" })}
        >
          <Alert severity={message.severity} variant="filled">
            {message.msg}
          </Alert>
        </Snackbar>
      ))}
    </main>
  );
}
